var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.960938,
    width: 32.4804,
    height: 32.4804,
    rx: 10,
    fill: "#FF704B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.556 6.95807H19.8116C18.5985 6.95807 17.435 7.43997 16.5773 8.29776C15.7195 9.15555 15.2376 10.319 15.2376 11.5321V14.2765H12.4932V17.9357H15.2376V25.2541H18.8968V17.9357H21.6412L22.556 14.2765H18.8968V11.5321C18.8968 11.2894 18.9931 11.0568 19.1647 10.8852C19.3363 10.7136 19.5689 10.6173 19.8116 10.6173H22.556V6.95807Z",
    stroke: "white",
    strokeWidth: 1.01217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.cfcdb32ed1cdaf9170277439b6ad8f0c.svg";
export { ForwardRef as ReactComponent };